import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

import { Icon } from '@vestigas/ui/atoms';
import { Tooltip } from '@vestigas/ui/molecules';

type P = PropsWithChildren<{
  readonly hint?: string;
  readonly htmlFor?: string;
  readonly id?: string;
  readonly isRequired?: boolean;
}> &
  ComponentStyling;

export const InputLabel = ({
  children,
  className,
  hint,
  htmlFor,
  id,
  isRequired,
  style,
}: P) => (
  <label
    className={cn('block text-sm text-tiga-text-default', className)}
    htmlFor={htmlFor}
    id={id}
    style={style}
  >
    {children}
    {isRequired ? (
      <span className="pl-[0.25ch] font-bold text-tiga-semantic-danger">*</span>
    ) : null}

    {hint ? (
      <Tooltip content={hint}>
        <span className="inline-block -translate-y-0.25 pl-0.5">
          <Icon
            className="cursor-help text-tiga-action-default transition-colors duration-300 hover:text-tiga-action-lighter"
            metaphor="infoOutlined"
            size="sm"
          />
        </span>
      </Tooltip>
    ) : null}
  </label>
);
